// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ActionDropdownController from "./action_dropdown_controller"
application.register("action-dropdown", ActionDropdownController)

import AlertController from "./alert_controller"
application.register("alert", AlertController)

import AttendanceMembersController from "./attendance_members_controller"
application.register("attendance-members", AttendanceMembersController)

import AvatarMenuController from "./avatar_menu_controller"
application.register("avatar-menu", AvatarMenuController)

import CascadeSelectController from "./cascade_select_controller"
application.register("cascade-select", CascadeSelectController)

import CheckboxSelectAllController from "./checkbox_select_all_controller"
application.register("checkbox-select-all", CheckboxSelectAllController)

import ClearInputController from "./clear_input_controller"
application.register("clear-input", ClearInputController)

import ClientSideValidationsController from "./client_side_validations_controller"
application.register("client-side-validations", ClientSideValidationsController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import ConditionalRequiredController from "./conditional_required_controller"
application.register("conditional-required", ConditionalRequiredController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import DistrictSelectController from "./district_select_controller"
application.register("district-select", DistrictSelectController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import FabMenuController from "./fab_menu_controller"
application.register("fab-menu", FabMenuController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import GroupFormController from "./group_form_controller"
application.register("group-form", GroupFormController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImportResultsModalController from "./import_results_modal_controller"
application.register("import-results-modal", ImportResultsModalController)

import JoditController from "./jodit_controller"
application.register("jodit", JoditController)

import MemberCourseFormController from "./member_course_form_controller"
application.register("member-course-form", MemberCourseFormController)

import MemberSectorToggleController from "./member_sector_toggle_controller"
application.register("member-sector-toggle", MemberSectorToggleController)

import NameDuplicateHintController from "./name_duplicate_hint_controller"
application.register("name-duplicate-hint", NameDuplicateHintController)

import NestedFieldsController from "./nested_fields_controller"
application.register("nested-fields", NestedFieldsController)

import PageTitleController from "./page_title_controller"
application.register("page-title", PageTitleController)

import ParticipantsSelectController from "./participants_select_controller"
application.register("participants-select", ParticipantsSelectController)

import PasswordConfirmationController from "./password_confirmation_controller"
application.register("password-confirmation", PasswordConfirmationController)

import PersistentCheckboxSelectAllController from "./persistent_checkbox_select_all_controller"
application.register("persistent-checkbox-select-all", PersistentCheckboxSelectAllController)

import PortalController from "./portal_controller"
application.register("portal", PortalController)

import ProgressBarController from "./progress_bar_controller"
application.register("progress-bar", ProgressBarController)

import QrDownloadController from "./qr_download_controller"
application.register("qr-download", QrDownloadController)

import QrScannerController from "./qr_scanner_controller"
application.register("qr-scanner", QrScannerController)

import ResetPasswordController from "./reset_password_controller"
application.register("reset-password", ResetPasswordController)

import RsvpController from "./rsvp_controller"
application.register("rsvp", RsvpController)

import SlimSelectController from "./slim_select_controller"
application.register("slim-select", SlimSelectController)

import SortableHeaderController from "./sortable_header_controller"
application.register("sortable-header", SortableHeaderController)

import TabValidationController from "./tab_validation_controller"
application.register("tab-validation", TabValidationController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import ToggleCourseIconController from "./toggle_course_icon_controller"
application.register("toggle-course-icon", ToggleCourseIconController)

import TransferFormController from "./transfer_form_controller"
application.register("transfer-form", TransferFormController)

import TurboModalController from "./turbo_modal_controller"
application.register("turbo-modal", TurboModalController)
